// extracted by mini-css-extract-plugin
export const page = "styles-module--page--vlfw1";
export const newsGroup = "styles-module--newsGroup--dKS4H";
export const heroSection = "styles-module--heroSection--nnYPR";
export const checkCachbackBox = "styles-module--checkCachbackBox--15PdP";